export default {
    'add-new-price-type': 'Add new price type',
    'edit-price-type': 'Edit new price type',
    'this-type': 'this type'
}